export enum OrderSource {
    WebPage = "web",
    App = "app",
    RestaurantWebsite = "restaurantWebsite",
}
